var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "productOfListBriefMain" },
    [
      _c(
        "div",
        { staticClass: "\n            productImgWrapper\n        " },
        [
          _c("img", {
            staticStyle: {
              position: "absolute",
              width: "100%",
              height: "100%",
              top: "0px",
              left: "0px"
            },
            attrs: { loading: "lazy", src: _vm.getImgUrl(_vm.productImg) }
          }),
          _vm._v(" "),
          _c(
            "van-tag",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.priceType,
                  expression: "priceType"
                }
              ],
              staticStyle: { position: "absolute", top: "0px", right: "0px" },
              attrs: { color: "#7232dd" }
            },
            [_vm._v(_vm._s(_vm.getPriceTypeName(_vm.priceType)))]
          ),
          _vm._v(" "),
          _vm.distance != null
            ? _c("ProductLeftBottomTag", {
                attrs: {
                  distance: _vm.distance,
                  transportationDescriptionList:
                    _vm.transportationDescriptionList
                }
              })
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "productTextDescriptionWrapper" }, [
        _c(
          "div",
          { staticClass: "\n                productName\n            " },
          [_vm._v("\n            " + _vm._s(_vm.productName) + "\n        ")]
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticStyle: { display: "flex", "align-items": "center" } },
          [
            _c("div", { staticClass: "priceWrapper" }, [
              _c(
                "span",
                { staticClass: "nowPrice" },
                [
                  _vm._v(
                    "\n                    ￥" +
                      _vm._s(_vm.lodash.round(_vm.productPrice, 1)) +
                      "\n                    "
                  ),
                  _vm.productOriginalPrice == -1 ? [_vm._v("起")] : _vm._e()
                ],
                2
              ),
              _vm._v(" "),
              _vm.productOriginalPrice != 0 && _vm.productOriginalPrice != -1
                ? _c("span", { staticClass: "originalPrice" }, [
                    _vm._v(
                      "￥" +
                        _vm._s(_vm.lodash.round(_vm.productOriginalPrice, 1))
                    )
                  ])
                : _vm._e()
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                ref: "addToCartView",
                staticClass: "addToCartView",
                on: {
                  click: function($event) {
                    $event.stopPropagation()
                  }
                }
              },
              [
                _vm.specificationList.length > 1
                  ? _c(
                      "van-badge",
                      {
                        staticClass: "selectSpecificationButton",
                        attrs: { content: _vm.purchasedNumber }
                      },
                      [
                        _c("button", { on: { click: _vm.showSpecification } }, [
                          _vm._v("选择规格")
                        ])
                      ]
                    )
                  : _c("ProductIncAndDesc", {
                      attrs: {
                        maxBuyNum: _vm.checkMaxBuyNum(
                          _vm.shopId,
                          _vm.productId,
                          _vm.specificationList[0].id
                        ),
                        maxNumber: _vm.specificationList[0].stock
                      },
                      on: { dataChange: _vm.updateCart },
                      model: {
                        value: _vm.purchasedNumber,
                        callback: function($$v) {
                          _vm.purchasedNumber = $$v
                        },
                        expression: "purchasedNumber"
                      }
                    })
              ],
              1
            )
          ]
        )
      ]),
      _vm._v(" "),
      _c("BaseParabolaAnimate", {
        ref: "addToCartAnimate",
        attrs: { imgPic: _vm.getImgUrl(_vm.productImg) }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }